
import React from 'react';
import { Typography, Collapse, Tag, Space } from 'antd';
import { CaretRightOutlined, ExperimentOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';

const { Text, Paragraph, Title } = Typography;
const { Panel } = Collapse;

// Markdown 组件自定义样式
const markdownComponents = {
    h1: ({ children }: any) => <Title level={3} style={{ marginTop: 24, marginBottom: 16, color: '#1f1f1f' }}>{children}</Title>,
    h2: ({ children }: any) => <Title level={4} style={{ marginTop: 24, marginBottom: 12, color: '#262626' }}>{children}</Title>,
    h3: ({ children }: any) => <Title level={5} style={{ marginTop: 16, marginBottom: 8, color: '#434343' }}>{children}</Title>,
    p: ({ children }: any) => <Paragraph style={{ lineHeight: '1.8', marginBottom: 16, fontSize: '14px', color: '#595959' }}>{children}</Paragraph>,
    ul: ({ children }: any) => <ul style={{ paddingLeft: 20, marginBottom: 16 }}>{children}</ul>,
    li: ({ children }: any) => <li style={{ marginBottom: 8, lineHeight: '1.6' }}>{children}</li>,
    strong: ({ children }: any) => <strong style={{ color: '#fa541c' }}>{children}</strong>,
    table: ({ children }: any) => (
        <div style={{ overflowX: 'auto', marginBottom: 24, border: '1px solid #f0f0f0', borderRadius: 8 }}>
            <table style={{ minWidth: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                {children}
            </table>
        </div>
    ),
    thead: ({ children }: any) => <thead style={{ background: '#fafafa', borderBottom: '1px solid #f0f0f0' }}>{children}</thead>,
    th: ({ children }: any) => <th style={{ padding: '12px 16px', fontWeight: 600, color: '#1f1f1f', textAlign: 'left' }}>{children}</th>,
    td: ({ children }: any) => <td style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', color: '#595959' }}>{children}</td>,
    blockquote: ({ children }: any) => (
        <div style={{ borderLeft: '4px solid #d9d9d9', paddingLeft: 12, color: '#8c8c8c', fontStyle: 'italic', margin: '8px 0' }}>
            {children}
        </div>
    ),
};

interface ReportViewProps {
    report: string;
}

export const ReportView: React.FC<ReportViewProps> = ({ report }) => {
    if (!report) return null;

    return (
        <div style={{ marginTop: 16, borderTop: '1px solid #f0f0f0', paddingTop: 16 }}>
            <Collapse
                defaultActiveKey={['1']}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                ghost
            >
                <Panel
                    header={
                        <Space>
                            <ExperimentOutlined style={{ color: '#1890ff' }} />
                            <Text strong style={{ fontSize: 15 }}>AI 洞察报告</Text>
                            <Tag color="purple">Rufus Insights</Tag>
                        </Space>
                    }
                    key="1"
                    style={{ background: '#f9f9f9', borderRadius: 8, border: 'none' }}
                >
                    <div style={{ padding: '0 8px' }}>
                        <ReactMarkdown components={markdownComponents}>
                            {report}
                        </ReactMarkdown>
                    </div>
                </Panel>
            </Collapse>
        </div>
    );
};
